import React, { useState } from "react";

import { PageLayout } from "components/PageLayout";
import { BoldText, MediumText, RegularText } from "components/Text";
import { Accordion } from "components/Accordion";
import { Divider, VerticalSpace } from "components/Spacing";
import { Icon } from "assets/icons";

import styles from "./styles.module.scss";

const FAQ = [
  {
    id: "docs",
    q: "Как создать документ?",
    a: "Откройте нужный тип в разделе «Документы», нажмите «Добавить», заполните шапку и добавьте товары. После проверки проведите документ.",
  },
  {
    id: "catalog",
    q: "Где вести каталог товаров?",
    a: "В справочнике «Товары»: слева группы, справа список. Новый товар создаётся кнопкой «+» в панели товаров.",
  },
  {
    id: "clients",
    q: "Как начислить бонусы клиенту?",
    a: "Откройте карточку клиента в справочнике «Клиенты» и воспользуйтесь блоком бонусов — начисление и история операций.",
  },
  {
    id: "reports",
    q: "Как сформировать отчёт?",
    a: "В разделе «Отчёты складские» выберите отчёт, укажите период и склады, затем нажмите «Сформировать». При необходимости выгрузите Excel.",
  },
];

/** Экран помощи — FAQ и контакты */
export const HelpPage = () => {
  const [openId, setOpenId] = useState(FAQ[0].id);

  return (
    <div className={styles.page}>
      <PageLayout
        className={styles.card}
        header={<BoldText>Помощь</BoldText>}
        bodyFill
      >
        <div className={styles.content}>
          <MediumText size={15}>Частые вопросы</MediumText>
          <VerticalSpace size={12} />
          <div className={styles.faq}>
            {FAQ.map((item) => {
              const open = openId === item.id;
              return (
                <div key={item.id} className={styles.faqItem}>
                  <Accordion
                    withIcon
                    collapsed={!open}
                    handleCollapse={() => setOpenId(open ? null : item.id)}
                    parent={
                      <MediumText size={14} className={styles.faqQuestion}>
                        {item.q}
                      </MediumText>
                    }
                  >
                    <RegularText
                      size={13}
                      color="muted"
                      className={styles.faqAnswer}
                    >
                      {item.a}
                    </RegularText>
                  </Accordion>
                </div>
              );
            })}
          </div>

          <VerticalSpace size={28} />
          <Divider />
          <VerticalSpace size={24} />

          <MediumText size={15}>Поддержка</MediumText>
          <VerticalSpace size={16} />
          <div className={styles.contacts}>
            <div className={styles.contactRow}>
              <span className={styles.contactIcon}>
                <Icon type="sms" size={18} />
              </span>
              <div>
                <RegularText size={13} color="muted">
                  Email
                </RegularText>
                <MediumText size={14}>support@florapoint.ru</MediumText>
              </div>
            </div>
            <div className={styles.contactRow}>
              <span className={styles.contactIcon}>
                <Icon type="info" size={18} />
              </span>
              <div>
                <RegularText size={13} color="muted">
                  Документация
                </RegularText>
                <MediumText size={14}>
                  Краткая справка по разделам — в этом экране. Полное руководство
                  появится позже.
                </MediumText>
              </div>
            </div>
          </div>

          <VerticalSpace size={28} />
          <RegularText size={13} color="muted">
            Florapoint Web · версия интерфейса 0.1.0
          </RegularText>
        </div>
      </PageLayout>
    </div>
  );
};
